import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { hasPermission } from "utility/helpers";
import { CellText, StyledEyeIcon } from "assets/js/Styles";
import { ACCOUNT_COS } from "utility/constants";

const congressmanEventColumns = ({ navigate }) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      style: { paddingLeft: 0, paddingRight: 0 },
      cell: () => null,
    },
    {
      name: "Member Name",
      selector: (record) => record["Congressman.fullName"],
      identifier: "Congressman.fullName",
      grow: 2,
      cell: (record) => (
        <CellText>
          {record.position === ACCOUNT_COS
            ? record["Congressman.cosName"]
            : record["Congressman.fullName"]}
        </CellText>
      ),
    },
    {
      name: "Position",
      selector: ({ position }) => position,
      identifier: "position",
      grow: 2,
      cell: ({ position }) => <CellText>{position || ""}</CellText>,
    },
    {
      name: "Events",
      selector: ({ eventCount }) => eventCount,
      identifier: "eventCount",
      grow: 2,
      sortable: true,
      cell: ({ eventCount }) => <CellText>{eventCount}</CellText>,
    },
    {
      name: "Action",
      selector: (row) => row?.id,
      sortable: false,
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row, index) =>
        hasPermission("event-update") && (
          <>
            <StyledEyeIcon
              size={16}
              id={`view-row--${index}`}
              onClick={() => {
                navigate(`/events/congressman/${row.congressmanId}/events`, {
                  state: {
                    row,
                  },
                });
              }}
            />
            <UncontrolledTooltip
              placement="auto"
              target={`view-row--${index}`}
            >
              {"View"}
            </UncontrolledTooltip>
          </>
        ),
    },
  ];
};

export default congressmanEventColumns;
